import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

import { Text } from '@ingka/common-styles-webc';

/**
 * Styles.
 */
export default class ConfigurationSummaryStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options.
	 * @param options.theme Theme.
	 * @returns CSS for ConfigurationSummary.
	 */
	public static getStyle(options: { theme: ITheme }): string {
		const { breakpoint, spacing, color } = options.theme;

		const gutterXlarge = spacing.space75;

		return css`
			${Text.CSS}

			:host {
				max-width: ${400 / 16}rem;
				display: grid;
				grid-template-columns: repeat(4, 1fr);
			}

			.priceHeader {
				grid-column: 1 / span 4;
				display: flex;
			}

			.priceHeaderPrice {
				flex: 1;
			}

			.disclaimer {
				grid-column: span 3;
			}

			kompis-injury-or-death-warning {
				grid-column: 1 / span 4;
				margin-top: ${spacing.space150 / 16}rem;
				margin-bottom: ${spacing.space50 / 16}rem;
			}

			.priceHeaderButtons {
				display: flex;
				align-items: flex-start;
				gap: ${spacing.space25 / 16}rem;
				padding-left: ${spacing.space25 / 16}rem;
			}

			.buttons {
				display: grid;
				grid-gap: ${spacing.space50 / 16}rem;
				grid-column: 1 / span 4;
				margin-top: ${spacing.space100 / 16}rem;
			}

			.buttons:empty {
				margin-top: 0;
			}

			.shareDesign,
			.saveDesign {
				display: flex;
				justify-content: flex-end;
			}

			.shareDesign .divider,
			.saveDesign .divider {
				width: ${spacing.space50 / 16}rem;
				flex-shrink: 0;
				margin-inline-end: ${3.5}rem;
			}

			kompis-financial-services {
				margin: ${spacing.space100 / 16}rem 0;
			}

			.priceExchangeRateContainer {
				color: ${color.neutral.grey700};
			}

			.totalPackageWeight {
				display: block;
			}

			@media print {
				.buttons,
				.priceHeaderButtons {
					display: none;
				}
			}

			@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
				:host {
					column-gap: ${gutterXlarge / 16}rem;
				}

				.buttons {
					grid-column: 1 / span 3;
				}
			}
		`;
	}
}
